import React from 'react';
import { intersection } from 'lodash';
import { connect } from 'react-redux';
import { getUser, getTranslations, getNotifications } from '../../actions/UserActions';
import { getDoctor, getBusinessById } from '../../actions/BusinessUserActions';
import setAuthorizationToken from '../../actions/setAuthorizationToken';

class AsyncRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false
    };
    props.dispatch(getTranslations(props.currentLanguage));
  }
  componentDidMount() {
    const path = this.props.props.router.location.pathname;
    const emailPath = path.split("/");
    if (emailPath[1] === 'businessemailverification' || emailPath[1] === 'emailverification' || emailPath[1] === 'confirmRequest' || emailPath[1] === 'resetpassword' || emailPath[1] === 'businessresetpassword') {
      localStorage.removeItem('CogitatioUserJWT');
    }
    const pathsArr = ['main', 'Login','services','rheumatologie', 'physiotherapie', 'sonographie', 'quickLinks', 'adminLogin', 'emailverification', 'news','resetpassword', 'businessemailverification', 'confirmRequest', 'businessresetpassword', 'aboutUs', 'contactUs', 'feedBacks', 'cookiesPolicy', 'termsOfUse', 'legalDisclaimer', 'privatePolicy', 'dataPolicy', 'ITresource','customers','partners','offices','notfall','ITProjects','Elearning','DigitalFirst','cloud','testimonials', 'leitgedanken', 'hausarztliche', 'medizinisches', 'ernahrungsberatung', 'venensprechstunde', 'wirBildenAus', 'impressionenPraxis', 'EasyPraxis', 'EasyPraxisNew'];
    if (
      localStorage.getItem('CogitatioUserJWT') === 'undefined' ||
      localStorage.getItem('CogitatioUserJWT') === '' ||
      localStorage.getItem('CogitatioUserJWT') === null
    ) {
      if (pathsArr.indexOf(emailPath[1]) >= 0) {
        this.props.props.router.push(this.props.props.router.location.pathname);
      } else {
        this.props.props.router.push('/Main');
      }
      this.props.loadingPromise.then(module => { this.component = module.default; this.setState({ loaded: true }); });
    } else {
      if (pathsArr.indexOf(emailPath[1]) >= 0) {
        this.props.props.router.push('/');
      } else {
        if (!this.props.userInfo) {
          setAuthorizationToken(localStorage.getItem('CogitatioUserJWT'));
          this.props.dispatch(getUser(localStorage.getItem('CogitatioUserJWT'))).then(() => {
            if (!this.props.userInfo.loggedIn) {
              localStorage.removeItem('CogitatioUserJWT');
              this.props.props.router.push('/main');
            }
            this.props.dispatch(getBusinessById(this.props.userInfo.businessId)).then(() => {
              this.props.dispatch(getNotifications(this.props.userInfo.id));
              this.props.props.router.push(this.props.props.router.location.pathname);
              this.props.loadingPromise.then(module => {
                this.component = module.default; this.setState({ loaded: true });
              });
            });
          });
        } else {
          this.props.dispatch(getNotifications(this.props.userInfo.id))
          this.props.props.router.push(this.props.props.router.location.pathname);
          this.props.loadingPromise.then(module => {
            this.component = module.default; this.setState({ loaded: true });
          });
        }
      }
    }
  }

  loadTranslations = (value, currentLanguage) => {
    const currentLang = currentLanguage ? currentLanguage : 'en';
    return this.props.translations ? this.props.translations[value] ? this.props.translations[value][currentLang] ? this.props.translations[value][currentLang] : value : value : value;
  }

  render() {
    if (this.state.loaded) {
      return <this.component {...this.props.props} loadTranslations={this.loadTranslations} />;
    }
    return (
      <i
        className="fa fa-spinner fa-spin fa-5x"
        style={{
          fontSize: '40px',
          color: '#007398',
          position: 'absolute',
          zIndex: 1000,
          margin: '17% 50%'
        }}
      />
    );
  }
}
function mapStateToProps(state) {
  return {
    translations: state.users.translations,
    userInfo: state.users.userInfo,
    currentLanguage: state.users.currentLanguage
  };
}
export default connect(mapStateToProps)(AsyncRoute);



// WEBPACK FOOTER //
// ./screens/Routes/AsyncRoute.js